/* import __COLOCATED_TEMPLATE__ from './side-drawer.hbs'; */
var _class;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
/* RESPONSIBLE TEAM: team-frontend-tech */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { ROOT_PARENT_SELECTOR } from '@intercom/pulse/lib/popover-utils';
let SideDrawer = (_class = class SideDrawer extends Component {
  constructor(...args) {
    super(...args);
    // SideDrawer has different nesting expectation to IcModal, we never expect
    // a drawer to be a child of another Popover. If that requirement ever
    // changes we will need to reimplement/generalise the logic inside the
    // IcModal component which dynamically renders the container "in place"
    // instead of at the top of the DOM in cases where it is nested
    _defineProperty(this, "alternateRenderContext", document.querySelector(ROOT_PARENT_SELECTOR));
  }
  initialFocus(element) {
    return element;
  }
  get showCloseIcon() {
    return this.args.showCloseIcon ?? true;
  }
  get hasFlexibleWidth() {
    return this.args.hasFlexibleWidth ?? false;
  }
  onBlanketClick(event) {
    if (this.args.onClose && (event.target.hasAttribute('data-side-drawer-wrapper') || event.target.hasAttribute('data-side-drawer-blanket'))) {
      this.args.onClose();
    }
  }
}, _applyDecoratedDescriptor(_class.prototype, "onBlanketClick", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onBlanketClick"), _class.prototype), _class);
export { SideDrawer as default };